import { Meta, StoryObj } from "@storybook/nextjs-vite";
import { EventCard } from "./EventCard";

const meta: Meta<typeof EventCard> = {
  title: "Event card",
  component: EventCard,
  argTypes: {
    hideDate: {
      type: "boolean",
    },
  },
};

export default meta;

export const DefaultCard: StoryObj<typeof EventCard> = {
  name: "Default card",
  args: {
    hideDate: false,
    presenters: [],
    tier: 1,
    type: "Event",
    title: "Title",
    isFeatured: false,
    fomoText: {
      upcomingText: "Don't miss it",
      todayText: "Today",
    },
    categories: ["Category 1", "Category 2"],
    startDate: "Mon, 12 Jan 2026 11:55:32 GMT",
    endDate: "Mon, 19 Jan 2026 11:55:32 GMT",
    location: "Location",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent ligula tortor, varius in elementum malesuada, placerat nec sem. Nullam tempus enim orci, eget imperdiet nisl aliquet ut. Nunc quis egestas mauris, eu accumsan arcu. Ut fermentum, sapien eu sagittis faucibus, tellus nunc lobortis augue, nec tincidunt ante neque non urna.",
    media: {
      type: "image",
      image:
        "https://p1.aprimocdn.net/solarwinds/68794fd2-c70f-45a8-ba05-b39300ed8929/placeholder_image_16x9_Original%20file.png",
    },
    link: {
      title: "Link",
      url: "#",
      dld: "dld",
      dlt: "dlt",
    },
  },
};

export const FeaturedCard: StoryObj<typeof EventCard> = {
  name: "Featured card",
  args: {
    hideDate: false,
    presenters: [],
    tier: 1,
    type: "Event",
    title: "Title",
    isFeatured: true,
    fomoText: {
      upcomingText: "Don't miss it",
      todayText: "Today",
    },
    categories: ["Category 1", "Category 2"],
    startDate: "Mon, 12 Jan 2026 11:55:32 GMT",
    endDate: "Mon, 19 Jan 2026 11:55:32 GMT",
    location: "Location",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent ligula tortor, varius in elementum malesuada, placerat nec sem. Nullam tempus enim orci, eget imperdiet nisl aliquet ut. Nunc quis egestas mauris, eu accumsan arcu. Ut fermentum, sapien eu sagittis faucibus, tellus nunc lobortis augue, nec tincidunt ante neque non urna.",
    media: {
      type: "image",
      image:
        "https://p1.aprimocdn.net/solarwinds/68794fd2-c70f-45a8-ba05-b39300ed8929/placeholder_image_16x9_Original%20file.png",
    },
    link: {
      title: "Link",
      url: "#",
      dld: "dld",
      dlt: "dlt",
    },
  },
};

export const TodayEvent: StoryObj<typeof EventCard> = {
  name: "Event taking place today",
  args: {
    hideDate: false,
    presenters: [],
    tier: 1,
    type: "Event",
    title: "Title",
    isFeatured: false,
    fomoText: {
      upcomingText: "Don't miss it",
      todayText: "Today",
    },
    categories: ["Category 1", "Category 2"],
    startDate: new Date(Date.now() - 604800000).toString(),
    endDate: new Date(Date.now() + 604800000).toString(),
    location: "Location",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent ligula tortor, varius in elementum malesuada, placerat nec sem. Nullam tempus enim orci, eget imperdiet nisl aliquet ut. Nunc quis egestas mauris, eu accumsan arcu. Ut fermentum, sapien eu sagittis faucibus, tellus nunc lobortis augue, nec tincidunt ante neque non urna.",
    media: {
      type: "image",
      image:
        "https://p1.aprimocdn.net/solarwinds/68794fd2-c70f-45a8-ba05-b39300ed8929/placeholder_image_16x9_Original%20file.png",
    },
    link: {
      title: "Link",
      url: "#",
      dld: "dld",
      dlt: "dlt",
    },
  },
};

export const UpcomingEvent: StoryObj<typeof EventCard> = {
  name: "Upcoming event",
  args: {
    hideDate: false,
    presenters: [],
    tier: 1,
    type: "Event",
    title: "Title",
    isFeatured: false,
    fomoText: {
      upcomingText: "Don't miss it",
      todayText: "Today",
    },
    categories: ["Category 1", "Category 2"],
    startDate: new Date(Date.now() + 86400000).toString(),
    endDate: new Date(Date.now() + 2 * 86400000).toString(),
    location: "Location",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent ligula tortor, varius in elementum malesuada, placerat nec sem. Nullam tempus enim orci, eget imperdiet nisl aliquet ut. Nunc quis egestas mauris, eu accumsan arcu. Ut fermentum, sapien eu sagittis faucibus, tellus nunc lobortis augue, nec tincidunt ante neque non urna.",
    media: {
      type: "image",
      image:
        "https://p1.aprimocdn.net/solarwinds/68794fd2-c70f-45a8-ba05-b39300ed8929/placeholder_image_16x9_Original%20file.png",
    },
    link: {
      title: "Link",
      url: "#",
      dld: "dld",
      dlt: "dlt",
    },
  },
};
